import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/services/login.service';
import { sha256 } from 'js-sha256'
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  password = ''

  constructor(private fb: FormBuilder,
    private _login: LoginService,
    private router: Router,
    public dialog: MatDialog) {

    this.options = fb.group({
      curp: ['', Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)],
      lastname: ['', Validators.minLength(3)],
      name: ['', Validators.minLength(3)],
      license: ['', Validators.minLength(5)],
      password: ['', Validators.minLength(4)],
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
    });
  }


  ngOnInit(): void {

    this.password = (Math.random() * 10000).toString().split('.')[0]
  }


  save() {
    let userData: any = {}
    Object.assign(userData, this.options.value)
    //userData.password = (userData.password)
    //console.log(userData)

    sessionStorage.setItem('registerCandidate', JSON.stringify(userData))

    this._login.registerCandidate(userData).subscribe(resolve => {
      //console.log(resolve)
      this.router.navigate(['homeuser/candidates']).then(() => {
        window.location.reload();
      })
    }, e => {
      if (e.error.message) {
        this.dialog.open(addRepeated)
      }
      console.log(e)
    })

  }
}

@Component({
  selector: 'app-addRepeated',
  templateUrl: './app-addRepeated.html',
})
export class addRepeated implements OnInit {
  constructor(public dialogRef: MatDialogRef<addRepeated>,
    private dialog: MatDialog,
    private _login: LoginService,
    private router: Router) { }

  data: any;
  ngOnInit(): void {
    this.data = JSON.parse(sessionStorage.getItem('registerCandidate'))
    this.data.curp = this.data.curp + '-'
    this.data.repeatedCandidate=true;
    console.log(this.data)
  }

  accept(): void {
    this._login.registerCandidate(this.data).subscribe(resolve => {
      //console.log(resolve)
      this.router.navigate(['homeuser/candidates']).then(() => {
        window.location.reload();
      })
    }, e => {
      console.log(e)
    })

    this.dialogRef.close();
  }
}